module.exports = "/fonts/intelliboard.ttf?0f69a01bd202e53aa9880a9646eb7639";